import { render, staticRenderFns } from "./newLotteryTitle.vue?vue&type=template&id=e67680e4&scoped=true&"
import script from "./newLotteryTitle.vue?vue&type=script&lang=js&"
export * from "./newLotteryTitle.vue?vue&type=script&lang=js&"
import style0 from "./newLotteryTitle.vue?vue&type=style&index=0&id=e67680e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67680e4",
  null
  
)

export default component.exports